export default __webpack_public_path__ + "static/media/crew-logo.37081bbb.svg";